import { useState, useEffect, useRef } from 'react';
import { useIsFocused } from '@react-navigation/native';

/**
 * Uses the initial value of isNew, but updates it when the screen is unfocused
 * @param isNew - the initial value of the new tag
 * @param key - the key for when to reset state
 * @returns the display value of the new tag
 */
const useIsNewDisplayState = (isNew: boolean, key: number | string | null = null) => {
    const [newIsVisible, setNewIsVisible] = useState(isNew);
    const keyRef = useRef(key);
    const isFocused = useIsFocused();

    useEffect(() => {
        // Handle navigation state changes
        if (!isFocused) {
            setNewIsVisible(isNew);
        }
    }, [isFocused, isNew]);

    useEffect(() => {
        if (keyRef.current !== key) {
            setNewIsVisible(isNew);
            keyRef.current = key;
        }
    }, [isNew, key]);

    return newIsVisible;
};

export default useIsNewDisplayState;
